export default __webpack_public_path__ + "static/media/smartUp.3107f585.png";